// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__RuwJq","Container":"Layout_Container__WuhAf","MainRow":"Layout_MainRow__Y0oyi","Content":"Layout_Content__qwptA","FullWidth":"Layout_FullWidth__U0tNe"};